export default __webpack_public_path__ + "static/media/email-light.b411a0b5.svg";